import { useCallback } from "react";
import { useCurrentAccountId } from "@zapier/identity";
import emitUserInteractionEvent, {
  UserInteractionName,
} from "./emitUserInteractionEvent";

interface CanvasChangeOwnerModalEvent {
  optionSelected: CanvasChangeOwnerModalAction;
  canvasId?: string;
  eventAction?: "click" | "view";
}

export type CanvasChangeOwnerModalAction =
  | "confirm"
  | "cancel"
  | "success"
  | "error";

export function useEmitCanvasChangeOwnerModalEvent() {
  const accountId = useCurrentAccountId();

  const emit = useCallback(
    ({
      optionSelected,
      canvasId,
      eventAction,
    }: CanvasChangeOwnerModalEvent) => {
      emitUserInteractionEvent({
        accountId,
        interactionName: UserInteractionName.CanvasChangeOwnerModal,
        optionSelected,
        eventAction: eventAction ?? "click",
        customTrackingFields: {
          canvas_id: canvasId,
        },
      });
    },
    [accountId],
  );

  return { emit };
}
